module.exports = __webpack_public_path__ + "img/carousel-4.4597e92.png";